var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import classnames from 'classnames';
import Icon from '@alife/next-icon';
var Tab = (function (_super) {
    __extends(Tab, _super);
    function Tab(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollLeft = function () {
            var $self = _this.self;
            if ($self) {
                var scrollAmount = Math.floor($self.offsetWidth / 3);
                if ($self.scrollLeft - scrollAmount < 10) {
                    $self.scrollLeft = 0;
                }
                else {
                    $self.scrollLeft -= scrollAmount;
                }
            }
            _this.calcArrow();
        };
        _this.scrollRight = function () {
            var $self = _this.self;
            if ($self) {
                var scrollAmount = Math.floor($self.offsetWidth / 3);
                if ($self.scrollLeft + scrollAmount > $self.scrollWidth - 10) {
                    $self.scrollLeft = $self.scrollWidth - $self.offsetWidth;
                }
                else {
                    $self.scrollLeft += scrollAmount;
                }
            }
            _this.calcArrow();
        };
        _this.state = {
            selectedValue: props.defaultValue || '',
        };
        _this.changeSelect = _this.changeSelect.bind(_this);
        return _this;
    }
    Tab.prototype.changeSelect = function (o) {
        this.props.onChange(o.value);
        this.setState({
            selectedValue: o.value
        });
    };
    Tab.prototype.componentDidMount = function () {
        this.updateValue(this.props.value);
        this.calcArrow();
    };
    Tab.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateValue(nextProps.value);
        this.calcArrow();
    };
    Tab.prototype.updateValue = function (value) {
        if (value && value !== this.state.selectedValue) {
            this.setState({
                selectedValue: value
            });
        }
    };
    Tab.prototype.calcArrow = function () {
        var _this = this;
        setTimeout(function () {
            var left = false;
            var right = false;
            var overflowScroll = _this.props.overflowScroll;
            var $self = _this.self;
            if (overflowScroll && $self) {
                if ($self.offsetWidth && $self.scrollWidth >= $self.offsetWidth) {
                    if ($self.scrollLeft > 0) {
                        left = true;
                    }
                    if ($self.offsetWidth + $self.scrollLeft < $self.scrollWidth) {
                        right = true;
                    }
                }
            }
            if (_this.left) {
                if (left) {
                    _this.left.classList.remove('hide');
                }
                else {
                    _this.left.classList.add('hide');
                }
            }
            if (_this.right) {
                if (right) {
                    _this.right.classList.remove('hide');
                }
                else {
                    _this.right.classList.add('hide');
                }
            }
        }, 16);
    };
    Tab.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, _b = _a.className, className = _b === void 0 ? '' : _b, overflowScroll = _a.overflowScroll, _c = _a.theme, theme = _c === void 0 ? 'badge' : _c;
        var selectedValue = this.state.selectedValue;
        return (React.createElement("div", { className: "simple-tab-container " + (overflowScroll ? 'overflow-scroll' : '') + " " + (theme === 'underline' ? 'simple-tab-theme-underline' : 'simple-tab-theme-badge') },
            React.createElement("ul", { ref: function (ref) { return _this.self = ref; }, className: "simple-tab " + className }, options.map(function (o) {
                return React.createElement(Option, { option: o, key: o.value, isSelected: o.value === selectedValue, onClick: _this.changeSelect });
            })),
            React.createElement("div", { ref: function (ref) { return _this.left = ref; }, className: "simple-tab-pager left hide", onClick: this.scrollLeft },
                React.createElement(Icon, { type: "arrow-left", size: "xxs" })),
            React.createElement("div", { ref: function (ref) { return _this.right = ref; }, className: "simple-tab-pager right hide", onClick: this.scrollRight },
                React.createElement(Icon, { type: "arrow-right", size: "xxs" }))));
    };
    return Tab;
}(React.Component));
function Option(props) {
    var option = props.option, isSelected = props.isSelected, onClick = props.onClick;
    var disabled = option.disabled;
    return (React.createElement("li", { className: classnames('tab-item', { selected: isSelected, disabled: disabled }), onClick: function () { return !disabled && onClick(option); } }, option.label));
}
export default Tab;

//# sourceMappingURL=index.js.map
